import { Component,ViewEncapsulation  } from '@angular/core';
import './app.component.css';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {}

